export default "__VITE_ASSET__DsfFKznD__"